module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/currency-picker/currency-picker.component.css
// module id = ./src/app/currency-picker/currency-picker.component.css
// module chunks = main